/** ***********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import uuid from 'uuid';
import { PDPAnalytics } from '../../analytics';

const INFORMATION_FIELD_TYPES = {
    COMPATIBILITY: 'compatibility',
    LANGUAGES: 'languages',
    VERSION: 'version',
};

const HELP_SUPPORT_LINK = {
    TROUBLESHOOTING_AND_HELP: 'troubleshooting-and-help',
    CONTACT_US: 'contact-us',
    TUTORIALS: 'tutorials',
    COMMUNITY_AND_FORUM: 'community-and-forum',
};

const SOCIAL_LINKS = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    YOUTUBE: 'youtube',
    INSTAGRAM: 'instagram',
};

const PDP_ACTION = {
    BACK_CLICK: 'back-click',
    VIEW_MORE_CLICK: 'view-more-click',
    HEADING_CLICK: 'heading-click',
    APP_CLICK: 'app-click',
    CATEGORY_LABEL_CLICK: 'category-label-click',
    CARD_CLICK: 'card-click',
    TUTORIAL_CLICK: 'tutorial-click',
    VIDEO_BANNER_CLICK: 'video-banner-click',
    LANGUAGES: 'languages',
    VERSION: 'version',
    COMPATIBILITY: 'compatibility',
};

const PDP_SECTION = {
    HEADER: 'header',
    OVERVIEW: 'overview',
    BEHANCE_GALLERY: 'behance-gallery',
    TUTORIALS: 'tutorials',
    HELP_AND_SUPPORT: 'help-and-support',
    STAY_CONNECTED: 'stay-connected',
    RELATED_APPS: 'related-apps',
    INFORMATION: 'information',
    OTHER_PLATFORMS: 'other-platforms',
    CATEGORIES: 'categories',
};

export function onBackClick(e, actionHandlerCallback) {
    const guid = uuid.v4();
    const actionParam = {
        actionObject: {
            sectionId: PDP_SECTION.HEADER,
            actionId: PDP_ACTION.BACK_CLICK,
        },
        guid,
    };
    actionHandlerCallback(
        e, PDP_SECTION.HEADER, PDP_ACTION.BACK_CLICK, actionParam
    );
    PDPAnalytics.backButtonClick(actionParam.actionObject);
}

export {
    INFORMATION_FIELD_TYPES,
    HELP_SUPPORT_LINK,
    SOCIAL_LINKS,
    PDP_ACTION,
    PDP_SECTION,
};
